export const MeetingOptionFragment = gql`
  fragment MeetingOptionFragment on Meeting {
    id
    uuid
    startTime
    location
    meetingBoard {
      id
      name
    }
    recordsOnMeeting {
      id
    }
  }
`
